import React, { useState, useEffect, useMemo, useRef } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaTicketAlt } from "react-icons/fa";
import { TicketPreviewModal } from "./TicketPreviewModal";
import { FiMoreVertical } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";
import { FaTicketSimple } from "react-icons/fa6";
import CreateTicket from "./CreateTicket";
import TaxSettingsDrawer from "./TaxSettings";
import { Link } from "react-router-dom";
import "./EventTickets.css";
import { MDBDataTable } from "mdbreact";
import {
  GetTicketsByID as GetTicketsByIDAPI,
  MakeTicketPrivate,
} from "../../../api/Webservices";
import { UpdateEventTickets } from "../../../api/Webservices";
import ConfirmationModal from "../../ReuseUI/ConfirmModel";
import { useUser } from "../../AdminUsers/UserContext";
import { GiInfinity } from "react-icons/gi";
const EventID = localStorage.getItem("eventId") || "";
const formatDatetimeForMysql = (dateString) => {
  if (!dateString) return null;
  try {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
};
const prepareTicketDataForApi = (ticketData) => {
  if (!ticketData) return null;
  const formattedData = JSON.parse(JSON.stringify(ticketData));
  if (formattedData.start_sale) {
    formattedData.start_sale = formatDatetimeForMysql(formattedData.start_sale);
  }
  if (formattedData.end_sale) {
    formattedData.end_sale = formatDatetimeForMysql(formattedData.end_sale);
  }
  if (formattedData.schedule_sale) {
    formattedData.schedule_sale = formatDatetimeForMysql(
      formattedData.schedule_sale
    );
  }
  if (formattedData.form_details) {
    if (typeof formattedData.form_details === "string") {
      try {
        JSON.parse(formattedData.form_details);
      } catch (e) {
        formattedData.form_details = JSON.stringify({
          fields: ["name", "email"],
        });
      }
    } else if (typeof formattedData.form_details === "object") {
      formattedData.form_details = JSON.stringify(formattedData.form_details);
    }
  }
  if (formattedData.guest_details) {
    if (formattedData.guest_details.start_sale) {
      formattedData.guest_details.start_sale = formatDatetimeForMysql(
        formattedData.guest_details.start_sale
      );
    }
    if (formattedData.guest_details.end_sale) {
      formattedData.guest_details.end_sale = formatDatetimeForMysql(
        formattedData.guest_details.end_sale
      );
    }
    if (formattedData.guest_details.schedule_sale) {
      formattedData.guest_details.schedule_sale = formatDatetimeForMysql(
        formattedData.guest_details.schedule_sale
      );
    }
    if (
      formattedData.guest_details.variable_prices &&
      Array.isArray(formattedData.guest_details.variable_prices)
    ) {
      formattedData.guest_details.variable_prices.forEach((vp) => {
        if (vp.valid_till) {
          vp.valid_till = formatDatetimeForMysql(vp.valid_till);
        }
      });
    }
    if (formattedData.guest_details.form_details) {
      if (typeof formattedData.guest_details.form_details === "string") {
        try {
          JSON.parse(formattedData.guest_details.form_details);
        } catch (e) {
          formattedData.guest_details.form_details = JSON.stringify({
            fields: ["name", "email"],
          });
        }
      } else if (typeof formattedData.guest_details.form_details === "object") {
        formattedData.guest_details.form_details = JSON.stringify(
          formattedData.guest_details.form_details
        );
      }
    }
  }
  return formattedData;
};
const GuestTicketModal = ({
  show,
  onHide,
  guestTicket,
  parentTicketName,
  apiTickets,
  parentTicketId,
}) => {
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isActive, setIsActive] = useState(
    guestTicket?.ticket_status === "onsale"
  );
  const [bgSuccessColor, setBgSuccessColor] = useState(
    guestTicket?.ticket_status === "onsale" ? "bg-success" : "bg-warning"
  );
  const [ticketStatus, setTicketStatus] = useState(
    guestTicket?.ticket_status || "onsale"
  );
  useEffect(() => {
    setIsActive(guestTicket?.ticket_status === "onsale");
    setBgSuccessColor(
      guestTicket?.ticket_status === "onsale" ? "bg-success" : "bg-warning"
    );
    setTicketStatus(guestTicket?.ticket_status || "onsale");
  }, [guestTicket]);
  const handleStatusToggle = async () => {
    if (!guestTicket) return;
    setIsStatusLoading(true);
    setError(null);
    try {
      const parentTicket = apiTickets.find(
        (ticket) => ticket.id === parentTicketId
      );
      if (!parentTicket) {
        setError("Could not find parent ticket information");
        setIsStatusLoading(false);
        return;
      }
      const newStatus = isActive ? "paused" : "onsale";
      const updatedTicketData = JSON.parse(JSON.stringify(parentTicket));
      updatedTicketData.guest_details.ticket_status = newStatus;
      updatedTicketData.guest_details.onsale_status =
        newStatus === "onsale" ? "enable" : "disable";
      const response = await UpdateEventTickets(updatedTicketData);
      if (response) {
        setIsActive(!isActive);
        setBgSuccessColor(!isActive ? "bg-success" : "bg-warning");
        setTicketStatus(newStatus);
        setError(null);
        setTimeout(() => {
          onHide(true);
        }, 1000);
      }
    } catch (error) {
      console.error("Error updating guest ticket status:", error);
      setError("Failed to update status. Please try again.");
    } finally {
      setIsStatusLoading(false);
    }
  };
  const renderModalHeader = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "14px 32px",
          borderBottom: "1px solid #f3f4f6",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <span
            style={{
              fontSize: "18px",
              fontWeight: "600",
              color: "#1a1a1a",
            }}
          >
            Guest Ticket for{" "}
            <span style={{ color: "#184778", fontWeight: "bold" }}>
              {parentTicketName}
            </span>
          </span>
        </div>
        <button
          onClick={() => onHide(false)}
          style={{
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#666666",
            padding: "8px",
            borderRadius: "4px",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#f3f4f6")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
        >
          <i className="fa fa-times"></i>
        </button>
      </div>
    );
  };
  const renderGuestTicketDetails = () => {
    return (
      <div style={{ padding: "22px" }}>
        <div style={{ marginBottom: "22px" }}>
          <h5
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              marginBottom: "8px",
              margin: "0 0 8px 0",
            }}
          >
            {guestTicket.ticket_name}
          </h5>
          <p
            style={{
              color: "#666666",
              fontSize: "14px",
              margin: "0",
            }}
          >
            {guestTicket.description || "No description available"}
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "24px",
          }}
        >
          {renderPriceCard()}
          {renderDetailsCard()}
        </div>
      </div>
    );
  };
  const renderPriceCard = () => {
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            Price:
          </span>
          {guestTicket.ticket_type === "free" ? (
            <span
              style={{
                padding: "4px 12px",
                backgroundColor: "#10b981",
                color: "#ffffff",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              Free
            </span>
          ) : (
            <span
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#1a1a1a",
              }}
            >
              {guestTicket.currency} {guestTicket.price || 0}
            </span>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            Quantity:
          </span>
          <span
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#1a1a1a",
            }}
          >
            {guestTicket.quantity}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            Status:
          </span>
          <span
            style={{
              padding: "4px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "500",
              backgroundColor:
                bgSuccessColor === "bg-success" ? "#10b981" : "#f59e0b",
              color: "#ffffff",
            }}
          >
            {ticketStatus}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "16px",
            borderTop: "1px solid #f3f4f6",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            Toggle Status:
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <label
              style={{
                position: "relative",
                display: "inline-block",
                width: "44px",
                height: "24px",
              }}
            >
              <input
                type="checkbox"
                checked={isActive}
                onChange={handleStatusToggle}
                disabled={isStatusLoading}
                style={{
                  opacity: 0,
                  width: 0,
                  height: 0,
                }}
              />
              <span
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: isActive ? "#184778" : "#ccc",
                  transition: "0.4s",
                  borderRadius: "24px",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    content: "",
                    height: "18px",
                    width: "18px",
                    left: isActive ? "23px" : "3px",
                    bottom: "3px",
                    backgroundColor: "white",
                    transition: "0.4s",
                    borderRadius: "50%",
                  }}
                ></span>
              </span>
            </label>
            {isStatusLoading && (
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  border: "2px solid #f3f3f3",
                  borderTop: "2px solid #184778",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                }}
              ></div>
            )}
          </div>
        </div>
        {error && (
          <div
            style={{
              color: "#ef4444",
              fontSize: "12px",
              marginTop: "8px",
            }}
          >
            {error}
          </div>
        )}
      </div>
    );
  };
  const renderDetailsCard = () => {
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h6
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "16px",
            margin: "0 0 16px 0",
          }}
        >
          Additional Details
        </h6>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 0",
              borderBottom: "1px solid #f3f4f6",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Ticket Type
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#1a1a1a",
              }}
            >
              {guestTicket.ticket_type || "Standard"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 0",
              borderBottom: "1px solid #f3f4f6",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Private
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#1a1a1a",
              }}
            >
              {guestTicket.private_ticket === "yes" ? "Yes" : "No"}
            </span>
          </div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 0",
              borderBottom: "1px solid #f3f4f6",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Sale Start
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#1a1a1a",
              }}
            >
              {guestTicket.start_sale ? new Date(guestTicket.start_sale).toLocaleString() : "Not specified"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 0",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Sale End
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#1a1a1a",
              }}
            >
              {guestTicket.end_sale ? new Date(guestTicket.end_sale).toLocaleString() : "Not specified"}
            </span>
          </div> */}
        </div>
      </div>
    );
  };
  const renderGuestTicketModal = () => {
    if (!guestTicket) return null;
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
          display: show ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
        }}
        onClick={() => onHide(false)}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            maxWidth: "800px",
            width: "100%",
            maxHeight: "90vh",
            overflow: "auto",
            position: "relative",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {renderModalHeader()}
          {renderGuestTicketDetails()}
        </div>
      </div>
    );
  };
  return renderGuestTicketModal();
};
const EventTickets = () => {
  const { checkPermission,adminName, adminProfile, eventUrl, getValidation } = useUser();
  console.log(eventUrl,"eventUrl")
  const [tickets, setTickets] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [apiTickets, setApiTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedParentTicketId, setSelectedParentTicketId] = useState(null);
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  const [showAddGroup, setShowAddGroup] = useState(false);
  const [showAddOns, setShowAddOns] = useState(false);
  const [showTaxSettings, setShowTaxSettings] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [selectedTickets, setSelectedTickets] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [ticketToEdit, setTicketToEdit] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [showTicketPreview, setShowTicketPreview] = useState(false);
  const [showGuestTicketModal, setShowGuestTicketModal] = useState(false);
  const [selectedGuestTicket, setSelectedGuestTicket] = useState(null);
  const [selectedParentTicketName, setSelectedParentTicketName] = useState("");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [ticketToDelete, setTicketToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [tabCounts, setTabCounts] = useState({
    all: 0,
    onsale: 0,
    paused: 0,
    scheduled: 0,
    soldout: 0,
    archived: 0,
    deleted: 0,
    draft: 0,
  });
  const [prevTicket, setPrevTicket] = useState(null);
  const computeTotalFee = (ticket) => {
    if (ticket.ticket_type === "free") {
      return <span className="fee_table_free">Free</span>;
    }
    const price = parseFloat(ticket.price) || 0;
    if (ticket.tax_type === "No Tax" || !ticket.tax_options || ticket.tax_options.length === 0) {
      return (
        <span className="fee_table_price">
          {ticket.currency} {price.toFixed(2)}
        </span>
      );
    }
    const isExcluding = ticket.tax_type === "Excluding Tax";
    let taxRate = 0;
    const hasIGST = ticket.tax_options.some(t => t.tax_name === "IGST");
    if (hasIGST) {
      taxRate = 18 / 100;
    } else {
      taxRate = ticket.tax_options.reduce((sum, tax) => sum + (parseFloat(tax.tax_percentage) || 0), 0) / 100;
    }
    let total;
    if (isExcluding) {
      total = price * (1 + taxRate);
    } else {
      total = price;
    }
    return (
      <span className="fee_table_price">
        {ticket.currency} {total.toFixed(2)}
      </span>
    );
  };
  const handleViewTicket = (ticket) => {
    setPrevTicket(ticket);
    setShowTicketPreview(true);
  };
  const loadTickets = () => {
    setLoading(true);
    const GetData = {
      event_id: localStorage.getItem("eventId") || "",
      ticket_status: activeTab === "all" ? "all" : activeTab,
      search: searchQuery || "",
    };
    GetTicketsByIDAPI(GetData)
      .then((res) => {
        if (res && res.data) {
          setApiTickets(res.data.tickets);
          if (res.data.statusSummary) {
            const newTabCounts = { all: 0 };
            res.data.statusSummary.forEach((status) => {
              newTabCounts[status.ticket_status] = status.count;
            });
            // Exclude deleted from all count
            newTabCounts.all = Object.values(newTabCounts).reduce(
              (sum, count, index) => {
                const keys = Object.keys(newTabCounts);
                if (keys[index] !== "all" && keys[index] !== "deleted") {
                  return sum + count;
                }
                return sum;
              },
              0
            );
            setTabCounts(newTabCounts);
          }
          if (res.data.tickets) {
            const formattedTickets = res.data.tickets.map((ticket) => ({
              id: ticket.id,
              name: ticket.ticket_name,
              groups: ticket.ticket_group || "--",
              qtyAvailable: ticket.quantity === 100000 ? <GiInfinity size={18} /> : ticket.quantity || 0,
              qtySold: 0,
              fee: computeTotalFee(ticket),
              privacy:
                ticket.private_ticket === "yes" ? (
                  <span className="private_div">Private</span>
                ) : (
                  <span className="public_div">Public</span>
                ),
              status: ticket.ticket_status || "Draft",
              color: getTicketColor(ticket.ticket_status),
              description: ticket.description,
              hasGuestTicket: !!ticket.guest_details,
              guestTicket: ticket.guest_details,
              private_ticket: ticket.private_ticket,
              private_ticket_url: ticket.private_ticket_url,
            }));
            let filteredTickets = formattedTickets;
            if (activeTab === "all") {
              filteredTickets = formattedTickets.filter(
                (ticket) => ticket.status !== "deleted"
              );
            }
            setTickets(filteredTickets);
          }
        }
        setLoading(false);
        setApiError(null);
      })
      .catch((err) => {
        setLoading(false);
        setApiError("Failed to load tickets. Please try again.");
      });
  };
  useEffect(() => {
    loadTickets();
  }, [activeTab, searchQuery]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target)
      ) {
        setTickets((prevTickets) =>
          prevTickets.map((ticket) => ({
            ...ticket,
            showMenu: false,
          }))
        );
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedTickets(tickets.map((ticket) => ticket.id));
    } else {
      setSelectedTickets([]);
    }
  };
  const handleSelectTicket = (id) => {
    if (selectedTickets.includes(id)) {
      setSelectedTickets(selectedTickets.filter((ticketId) => ticketId !== id));
    } else {
      setSelectedTickets([...selectedTickets, id]);
    }
  };
  const handleOpenTaxSettings = () => {
    setShowTaxSettings(true);
  };
  const getTicketColor = (status) => {
    switch (status) {
      case "published":
        return "green";
      case "archived":
        return "purple";
      case "draft":
        return "orange";
      default:
        return "green";
    }
  };
  const handleViewGuestTicket = (ticket) => {
    if (ticket.hasGuestTicket && ticket.guestTicket) {
      setSelectedGuestTicket(ticket.guestTicket);
      setSelectedParentTicketName(ticket.name);
      setSelectedParentTicketId(ticket.id);
      setShowGuestTicketModal(true);
    }
  };
  const handleCloseGuestTicketModal = (statusUpdated = false) => {
    setShowGuestTicketModal(false);
    setSelectedGuestTicket(null);
    setSelectedParentTicketName("");
    setSelectedParentTicketId(null);
    if (statusUpdated) {
      loadTickets();
    }
  };
  const formatDateForMySQL = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };
  const handleEditTicket = async (ticket) => {
    const hasPermission = await checkPermission("Tickets", "update");
    if (!hasPermission) return;
    const fullTicketData = apiTickets.find((t) => t.id === ticket.id);
    if (fullTicketData) {
      const ticketToEdit = {
        id: fullTicketData.id,
        name: fullTicketData.ticket_name,
        qtyAvailable: fullTicketData.quantity?.toString() || "",
        description: fullTicketData.description || "",
        group: fullTicketData.ticket_group || "",
        ticket_min_order: fullTicketData.ticket_min_order,
        ticket_max_order: fullTicketData.ticket_max_order,
        qrcode: fullTicketData.qrcode === "yes" ? true : false,
        pricingType: fullTicketData.ticket_type || "free",
        currency: fullTicketData.currency || "",
        priceOption: fullTicketData.pricing_option || "fixed",
        fixedPrice: fullTicketData.price?.toString() || "",
        taxType: fullTicketData.tax_type || "No Tax",
        taxOption: fullTicketData.tax_option || [],
        variablePrices: Array.isArray(fullTicketData.variable_prices)
          ? fullTicketData.variable_prices.map((vp) => ({
            price: vp.price?.toString() || "",
            validUntilDate: vp.valid_till ? new Date(vp.valid_till) : null,
            validUntilTime: vp.valid_till ? new Date(vp.valid_till) : null,
          }))
          : [{ price: "", validUntilDate: null, validUntilTime: null }],
        taxEnabled: fullTicketData.tax_type !== "No Tax",
        taxIncluded: fullTicketData.tax_type === "Including Tax",
        taxRate:
          fullTicketData.tax_options?.[0]?.tax_percentage?.toString() || "18",
        taxName: fullTicketData.tax_options?.[0]?.tax_name || "GST",
        isPrivate: fullTicketData.private_ticket === "yes",
        showSchedule: fullTicketData.schedule_sale_enabled === "yes",
        saleStartDate: fullTicketData.start_sale
          ? formatDateForMySQL(fullTicketData.start_sale)
          : null,
        saleStartTime: fullTicketData.start_sale
          ? formatDateForMySQL(fullTicketData.start_sale)
          : null,
        saleEndDate: fullTicketData.end_sale
          ? formatDateForMySQL(fullTicketData.end_sale)
          : null,
        saleEndTime: fullTicketData.end_sale
          ? formatDateForMySQL(fullTicketData.end_sale)
          : null,
        showLimits: !!(
          fullTicketData.ticket_min_order || fullTicketData.ticket_max_order
        ),
        ticket_min_order: fullTicketData.ticket_min_order?.toString() || "1",
        ticket_max_order: fullTicketData.ticket_max_order?.toString() || "",
        ticketStatus: fullTicketData.onsale_status || "paused",
        selected_form: fullTicketData.selected_form,
        form_details: fullTicketData.form_details,
        onsale_status: fullTicketData.onsale_status,
        _originalData: fullTicketData,
      };
      if (fullTicketData.guest_details) {
        const guestDetails = fullTicketData.guest_details;
        let guestVariablePrices = [];
        if (
          guestDetails.variable_prices &&
          Array.isArray(guestDetails.variable_prices) &&
          guestDetails.variable_prices.length > 0
        ) {
          guestVariablePrices = guestDetails.variable_prices.map((vp) => ({
            price: vp.price?.toString() || "",
            validUntilDate: vp.valid_till ? new Date(vp.valid_till) : null,
            validUntilTime: vp.valid_till ? new Date(vp.valid_till) : null,
          }));
        } else {
          guestVariablePrices = [
            { price: "", validUntilDate: null, validUntilTime: null },
          ];
        }
        let parsedFormDetails = {};
        try {
          parsedFormDetails = guestDetails.form_details
            ? JSON.parse(guestDetails.form_details)
            : {
              id: guestDetails.selected_form,
              name: "Guest Registration Form",
              fields: [],
            };
        } catch (e) {
          console.warn("Error parsing guest form_details:", e);
          parsedFormDetails = {
            id: guestDetails.selected_form,
            name: "Guest Registration Form",
            fields: [],
          };
        }
        const formattedGuestTicket = {
          id: guestDetails.id || null,
          name: guestDetails.ticket_name || "",
          qtyAvailable: guestDetails.quantity?.toString() || "",
          description: guestDetails.description || "",
          pricingType: guestDetails.ticket_type,
          currency: guestDetails.currency || "INR",
          priceOption: guestDetails.pricing_option || "fixed",
          fixedPrice: guestDetails.price?.toString() || "",
          variablePrices: guestVariablePrices,
          taxEnabled: guestDetails.tax_type !== "No Tax",
          taxIncluded: guestDetails.tax_type === "Including Tax",
          taxRate:
            (guestDetails.tax_options &&
              guestDetails.tax_options[0]?.tax_percentage?.toString()) ||
            "18",
          taxName:
            (guestDetails.tax_options &&
              guestDetails.tax_options[0]?.tax_name) ||
            "GST",
          showLimits: true,
          minLimit: guestDetails.ticket_min_order?.toString() || "1",
          maxLimit: guestDetails.ticket_max_order?.toString() || "1",
          qrcode: guestDetails.qrcode === "yes",
          selected_form: guestDetails.selected_form || null,
          form_details: guestDetails.form_details || "",
          selectedForm: {
            id: guestDetails.selected_form || null,
            name: parsedFormDetails.name || "Guest Registration Form",
            fields: parsedFormDetails.fields || [],
          },
          addons: guestDetails.addons || [],
          ticketStatus: guestDetails.ticket_status || "onsale",
          showSchedule: guestDetails.schedule_sale_enabled === "yes",
          saleStartDate: guestDetails.start_sale
            ? formatDateForMySQL(guestDetails.start_sale)
            : null,
          saleStartTime: guestDetails.start_sale
            ? formatDateForMySQL(guestDetails.start_sale)
            : null,
          saleEndDate: guestDetails.end_sale
            ? formatDateForMySQL(guestDetails.end_sale)
            : null,
          saleEndTime: guestDetails.end_sale
            ? formatDateForMySQL(guestDetails.end_sale)
            : null,
        };
        ticketToEdit.guestTicket = formattedGuestTicket;
        ticketToEdit.guest_details = formattedGuestTicket;
        ticketToEdit.showGuestTicket = true;
      }
      if (fullTicketData.addons && Array.isArray(fullTicketData.addons)) {
        const formattedAddons = fullTicketData.addons.map((addon) => {
          const variants = Array.isArray(addon.variant_options)
            ? addon.variant_options.map((v) => ({
              name: v.name || "",
              quantity: v.quantity || 0,
              price: v.price || 0,
            }))
            : [];
          const selectedVariant =
            variants.length > 0
              ? { name: variants[0].name, price: variants[0].price }
              : null;
          return {
            id: addon.id,
            name: addon.add_on_name || "",
            description: addon.description || "",
            price: addon.price || (variants.length > 0 ? variants[0].price : 0),
            currency: addon.currency || "INR",
            variants: variants,
            hasVariants: variants.length > 0,
            type: addon.addons_type || "variant",
            status: addon.addon_status || "onsale",
            quantity: 1,
            isMandatory: addon.isMandatory || false,
            selectedVariant: selectedVariant,
          };
        });
        ticketToEdit.selectedAddons = formattedAddons;
        ticketToEdit.addons = fullTicketData.addons;
      }
      setEditMode(true);
      setTicketToEdit(ticketToEdit);
      setShowCreateTicket(true);
    } else {
      console.warn(
        "Could not find full ticket data for editing. Using limited data."
      );
      const basicTicketToEdit = {
        ...ticket,
        variablePrices: [
          { price: "", validUntilDate: null, validUntilTime: null },
        ],
        guest_details: ticket.guestTicket || null,
        guestTicket: ticket.guestTicket || null,
        addons: [],
        ticket_addons: [],
      };
      setEditMode(true);
      setTicketToEdit(basicTicketToEdit);
      setShowCreateTicket(true);
    }
  };
  const handleAddGroup = () => {
    setShowAddGroup(false);
  };
  const handleAddOns = () => {
    setShowAddOns(false);
  };
  const TicketIcon = ({ color }) => (
    <div
      className={`ticket-icon bg-${color}`}
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: getColorCode(color),
      }}
    >
      <FaTicketSimple color="white" />
    </div>
  );
  const getColorCode = (color) => {
    switch (color) {
      case "purple":
        return "#8a2be2";
      case "green":
        return "#28a745";
      case "orange":
        return "#fd7e14";
      default:
        return "#0d6efd";
    }
  };
  const PrivacyToggle = ({
    privacy,
    ticketId,
    setTickets,
    apiTickets,
    setApiTickets,
    loadTickets,
  }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [currentPrivacy, setCurrentPrivacy] = useState(
      privacy?.props?.children === 'Private' ? 'Private' : 'Public'
    )
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)
    const dropdownRef = useRef(null)
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [])
    const privacyOptions = ['Public', 'Private']
    const handlePrivacyChange = async (newPrivacy, e) => {
      e.stopPropagation()
      setIsLoading(true)
      setError(null)
      try {
        const ticketData = apiTickets.find((ticket) => ticket.id === ticketId)
        if (!ticketData) {
          setError('Could not find ticket data')
          setIsLoading(false)
          return
        }
        const updatedTicketData = JSON.parse(JSON.stringify(ticketData))
        updatedTicketData.private_ticket =
          newPrivacy === 'Private' ? 'yes' : 'no'
        const payload = {
          ticket_id: updatedTicketData.id,
          event_id: updatedTicketData.event_id,
          private_ticket: newPrivacy === 'Private' ? 'yes' : 'no',
        }
        const response = await MakeTicketPrivate(payload)
        if (response) {
          setTickets((prevTickets) =>
            prevTickets.map((ticket) =>
              ticket.id === ticketId
                ? {
                    ...ticket,
                    privacy:
                      newPrivacy === 'Private' ? (
                        <span className="private_div">Private</span>
                      ) : (
                        <span className="public_div">Public</span>
                      ),
                  }
                : ticket
            )
          )
          setApiTickets((prevApiTickets) =>
            prevApiTickets.map((ticket) =>
              ticket.id === ticketId
                ? {
                    ...ticket,
                    private_ticket: newPrivacy === 'Private' ? 'yes' : 'no',
                  }
                : ticket
            )
          )
setCurrentPrivacy(newPrivacy)
setTimeout(() => loadTickets(), 500)
       
        }
      } catch (error) {
        console.error('Error updating ticket privacy:', error)
        setError('Failed to update privacy. Please try again.')
      } finally {
        setIsLoading(false)
        setIsOpen(false)
      }
    }
    return (
      <div
        style={{ position: 'relative' }}
        ref={dropdownRef}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={(e) => {
            e.stopPropagation()
            setIsOpen(!isOpen)
          }}
          disabled={isLoading}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '6px 12px',
            border: '1px solid #e5e7eb',
            borderRadius: '6px',
            backgroundColor: '#ffffff',
            color: '#374151',
            fontSize: '13px',
            fontWeight: '500',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s ease-in-out',
            minWidth: '80px',
            justifyContent: 'space-between',
          }}
          onMouseOver={(e) => {
            if (!isLoading) {
              e.target.style.borderColor = '#d1d5db'
              e.target.style.backgroundColor = '#f9fafb'
            }
          }}
          onMouseOut={(e) => {
            if (!isLoading) {
              e.target.style.borderColor = '#e5e7eb'
              e.target.style.backgroundColor = '#ffffff'
            }
          }}
        >
          {isLoading ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  border: '2px solid #f3f3f3',
                  borderTop: '2px solid #184778',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }}
              ></div>
              <span>Updating</span>
            </div>
          ) : (
            <>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor:
                      currentPrivacy === 'Private' ? '#f59e0b' : '#10b981',
                  }}
                ></div>
                <span>{currentPrivacy}</span>
              </div>
              <i
                className="fa fa-chevron-down"
                style={{
                  fontSize: '10px',
                  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                }}
              ></i>
            </>
          )}
        </button>
        {error && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '0',
              right: '0',
              color: '#ef4444',
              fontSize: '11px',
              marginTop: '4px',
              padding: '2px 4px',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '4px',
              zIndex: 1001,
            }}
          >
            {error}
          </div>
        )}
        {isOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '0',
              right: '0',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              marginTop: '4px',
              overflow: 'hidden',
            }}
          >
            {privacyOptions.map((option) => (
              <div
                key={option}
                onClick={(e) => handlePrivacyChange(option, e)}
                style={{
                  padding: '10px 12px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  color: '#374151',
                  backgroundColor:
                    option === currentPrivacy ? '#f3f4f6' : '#ffffff',
                  borderBottom:
                    option !== privacyOptions[privacyOptions.length - 1]
                      ? '1px solid #f3f4f6'
                      : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'background-color 0.2s ease-in-out',
                }}
                onMouseOver={(e) => {
                  if (option !== currentPrivacy) {
                    e.target.style.backgroundColor = '#f9fafb'
                  }
                }}
                onMouseOut={(e) => {
                  if (option !== currentPrivacy) {
                    e.target.style.backgroundColor = '#ffffff'
                  }
                }}
              >
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor:
                      option === 'Private' ? '#f59e0b' : '#10b981',
                  }}
                ></div>
                <span>{option}</span>
                {option === currentPrivacy && (
                  <i
                    className="fa fa-check"
                    style={{
                      fontSize: '10px',
                      color: '#184778',
                      marginLeft: 'auto',
                    }}
                  ></i>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
  const handleDeleteConfirmed = async () => {
    if (!ticketToDelete) return;
    const ticket = ticketToDelete;
    setTicketToDelete(null);
    setShowDeleteConfirmation(false);
    try {
      const ticketData = apiTickets.find((t) => t.id === ticket.id);
      if (!ticketData) {
        console.error("Could not find ticket data for deletion");
        return;
      }
      const updatedTicketData = JSON.parse(JSON.stringify(ticketData));
      updatedTicketData.ticket_status = "deleted";
      const response = await UpdateEventTickets(updatedTicketData);
      if (response) {
        setTickets(tickets.filter((t) => t.id !== ticket.id));
        setTabCounts({
          ...tabCounts,
          all: tabCounts.all > 0 ? tabCounts.all - 1 : 0,
          deleted: (tabCounts.deleted || 0) + 1,
        });
      }
    } catch (error) {
      console.error("Error deleting ticket:", error);
    }
  };
  const StatusBadge = ({
    status,
    ticketId,
    setTickets,
    apiTickets,
    setApiTickets,
  }) => {
    const [currentStatus, setCurrentStatus] = useState(status);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const isActive = currentStatus === "On sale" || currentStatus === "onsale";
    const handleStatusToggle = async (e) => {
      const hasPermission = await checkPermission("Tickets", "update");
      if (!hasPermission) return;
      e.stopPropagation();
      setIsLoading(true);
      setError(null);
      try {
        const ticketData = apiTickets.find((ticket) => ticket.id === ticketId);
        if (!ticketData) {
          setError("Could not find ticket data");
          setIsLoading(false);
          return;
        }
        const newStatus = isActive ? "paused" : "onsale";
        const updatedTicketData = JSON.parse(JSON.stringify(ticketData));
        updatedTicketData.ticket_status = newStatus;
        updatedTicketData.onsale_status =
          newStatus === "onsale" ? "enable" : "disable";
        const response = await UpdateEventTickets(updatedTicketData);
        if (response) {
          setTickets((prevTickets) =>
            prevTickets.map((ticket) =>
              ticket.id === ticketId ? { ...ticket, status: newStatus } : ticket
            )
          );
getValidation()
          setApiTickets((prevApiTickets) =>
            prevApiTickets.map((ticket) =>
              ticket.id === ticketId
                ? {
                  ...ticket,
                  ticket_status: newStatus,
                  onsale_status:
                    newStatus === "onsale" ? "enable" : "disable",
                }
                : ticket
            )
          );
          setCurrentStatus(newStatus === "onsale" ? "On sale" : "Paused");
          setTabCounts((prevCounts) => ({
            ...prevCounts,
            [isActive ? "onsale" : "paused"]:
              prevCounts[isActive ? "onsale" : "paused"] - 1,
            [newStatus]: (prevCounts[newStatus] || 0) + 1,
          }));
        }
      } catch (error) {
        console.error("Error updating ticket status:", error);
        setError("Failed to update status. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label
            style={{
              position: "relative",
              display: "inline-block",
              width: "44px",
              height: "24px",
            }}
          >
            <input
              type="checkbox"
              checked={isActive}
              onChange={handleStatusToggle}
              disabled={isLoading || currentStatus === "deleted"}
              style={{
                opacity: 0,
                width: 0,
                height: 0,
              }}
            />
            <span
              style={{
                position: "absolute",
                cursor: "pointer",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: isActive ? "#184778" : "#ccc",
                transition: "0.4s",
                borderRadius: "24px",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  content: "",
                  height: "18px",
                  width: "18px",
                  left: isActive ? "23px" : "3px",
                  bottom: "3px",
                  backgroundColor: "white",
                  transition: "0.4s",
                  borderRadius: "50%",
                }}
              ></span>
            </span>
          </label>
          {isLoading && (
            <div
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid #f3f3f3",
                borderTop: "2px solid #184778",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            ></div>
          )}
        </div>
        {error && (
          <div
            style={{
              color: "#ef4444",
              fontSize: "11px",
              marginTop: "4px",
            }}
          >
            {error}
          </div>
        )}
      </div>
    );
  };
  const TicketActions = ({ ticket }) => {
    const [showMenu, setShowMenu] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [error, setError] = useState(null)
    const [copySuccess, setCopySuccess] = useState(false) // ADD THIS LINE
    const menuRef = useRef(null)
    useEffect(() => {
      function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
          setShowMenu(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [])
    const handleEditClick = async (e) => {
      const hasPermission = await checkPermission('Tickets', 'update')
      if (!hasPermission) return
      e.stopPropagation()
      handleEditTicket(ticket)
      setShowMenu(false)
    }
    const handleDeleteClick = async (e) => {
      const hasPermission = await checkPermission('Tickets', 'delete')
      if (!hasPermission) return
      e.stopPropagation()
      setTicketToDelete(ticket)
      setShowDeleteConfirmation(true)
      setShowMenu(false)
    }
    // ADD THIS NEW HANDLER
    const handleCopyPrivateLink = async (e) => {
      e.stopPropagation()
      if (!ticket.private_ticket_url) {
        setError('Private link not available')
        return
      }
      try {
       const fullUrl = `${eventUrl}/${ticket?.private_ticket_url || ''}`
        await navigator.clipboard.writeText(fullUrl)
        setCopySuccess(true)
        setTimeout(() => setCopySuccess(false), 2000)
      } catch (err) {
        console.error('Failed to copy private link:', err)
        setError('Failed to copy link')
      }
      setShowMenu(false)
    }
    return (
      <div
        style={{ position: 'relative' }}
        ref={menuRef}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={(e) => {
            e.stopPropagation()
            setShowMenu(!showMenu)
          }}
          disabled={isDeleting || ticket.status === 'deleted'}
          style={{
            background: 'none',
            border: 'none',
            cursor:
              isDeleting || ticket.status === 'deleted'
                ? 'not-allowed'
                : 'pointer',
            padding: '8px',
            borderRadius: '4px',
            color: '#666666',
            fontSize: '16px',
            transition: 'all 0.2s ease-in-out',
          }}
          onMouseOver={(e) => {
            if (!isDeleting && ticket.status !== 'deleted') {
              e.target.style.backgroundColor = '#f3f4f6'
              e.target.style.color = '#374151'
            }
          }}
          onMouseOut={(e) => {
            if (!isDeleting && ticket.status !== 'deleted') {
              e.target.style.backgroundColor = 'transparent'
              e.target.style.color = '#666666'
            }
          }}
        >
          {isDeleting ? (
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #f3f3f3',
                borderTop: '2px solid #184778',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
              }}
            ></div>
          ) : (
            <FiMoreVertical />
          )}
        </button>
        {error && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: '0',
              color: '#ef4444',
              fontSize: '11px',
              marginTop: '4px',
              padding: '4px 8px',
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '4px',
              zIndex: 1001,
              whiteSpace: 'nowrap',
            }}
          >
            {error}
          </div>
        )}
        {/* ADD THIS NEW SUCCESS TOAST */}
        {copySuccess && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: '0',
              color: '#10b981',
              fontSize: '11px',
              marginTop: '4px',
              padding: '4px 8px',
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              borderRadius: '4px',
              zIndex: 1001,
              whiteSpace: 'nowrap',
            }}
          >
            Copied to clipboard!
          </div>
        )}
        {showMenu && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: '0',
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
              marginTop: '4px',
              minWidth: '140px',
              overflow: 'hidden',
            }}
          >
            <div
              onClick={handleEditClick}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontSize: '13px',
                color: '#374151',
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #f3f4f6',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'background-color 0.2s ease-in-out',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f9fafb')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#ffffff')}
            >
              <FaEdit style={{ fontSize: '12px', color: '#184778' }} />
              <span>Edit</span>
            </div>
            {/* ADD THIS NEW CONDITIONAL MENU ITEM */}
            {ticket.private_ticket === 'yes' && ticket.private_ticket_url && (
              <div
                onClick={handleCopyPrivateLink}
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  color: '#374151',
                  backgroundColor: '#ffffff',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  transition: 'background-color 0.2s ease-in-out',
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = '#f9fafb')
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = '#ffffff')}
              >
                <i
                  className="fa fa-copy"
                  style={{ fontSize: '12px', color: '#6b7280' }}
                />
                <span>Copy Private Link</span>
              </div>
            )}
            <div
              onClick={handleDeleteClick}
              style={{
                padding: '12px 16px',
                cursor: 'pointer',
                fontSize: '13px',
                color: '#ef4444',
                backgroundColor: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'background-color 0.2s ease-in-out',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#fef2f2')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#ffffff')}
            >
              <FaTrashAlt style={{ fontSize: '12px' }} />
              <span>Delete</span>
            </div>
          </div>
        )}
      </div>
    )
  }
  const renderStatus = (ticket) => (
    <StatusBadge
      status={ticket.status}
      ticketId={ticket.id}
      setTickets={setTickets}
      apiTickets={apiTickets}
      setApiTickets={setApiTickets}
      setTabCounts={setTabCounts}
    />
  );
  const handleRowClick = (ticket, e) => {
    const isInteractiveElement = e.target.closest(
      'button, input, select, a, .dropdown, .form-check, [role="button"], [data-action="ticket-actions"]'
    );
    if (!isInteractiveElement) {
      handleEditTicket(ticket);
    }
  };
  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: <div className="fw-bold">Ticket Name</div>,
          field: "name",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Total Qty </div>,
          field: "qtyAvailable",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Fee</div>,
          field: "fee",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Privacy</div>,
          field: "privacy",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Status</div>,
          field: "status",
          sort: "asc",
        },
        {
          label: <div className="fw-bold">Actions</div>,
          field: "actions",
          width: 80,
        },
      ],
      rows: tickets.map((ticket) => ({
        name: (
          <div className="d-flex align-items-center">
            <TicketIcon color={ticket.color} />
            <div className="ms-2">
              <div className="fw-medium">{ticket.name}</div>
              {ticket.hasGuestTicket && (
                <div>
                  <small className="text-muted d-flex align-items-center mb-1">
                    with guest ticket
                  </small>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewGuestTicket(ticket);
                    }}
                    style={{
                      padding: "4px 12px",
                      fontSize: "11px",
                      fontWeight: "500",
                      border: "1px solid #184778",
                      backgroundColor: "transparent",
                      color: "#184778",
                      borderRadius: "16px",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#184778";
                      e.target.style.color = "#ffffff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#184778";
                    }}
                    title="View Guest Ticket"
                  >
                    <i
                      className="fa fa-ticket"
                      style={{ fontSize: "10px" }}
                    ></i>
                    Guest Ticket
                  </button>
                </div>
              )}
            </div>
          </div>
        ),
        groups: ticket.groups,
        qtyAvailable: ticket.qtyAvailable,
        qtySold: ticket.qtySold,
        fee: ticket.fee,
        privacy: (
          <PrivacyToggle
            privacy={ticket.privacy}
            ticketId={ticket.id}
            setTickets={setTickets}
            apiTickets={apiTickets}
            setApiTickets={setApiTickets}
            loadTickets={loadTickets}
          />
        ),
        status: renderStatus(ticket),
        actions: (
          <div onClick={(e) => e.stopPropagation()}>
            <TicketActions ticket={ticket} />
          </div>
        ),
        clickEvent: (e) => handleRowClick(ticket, e),
      })),
    }),
    [tickets, selectedTickets, apiTickets]
  );
  const handleCreateTicket = async () => {
    const hasPermission = await checkPermission("Tickets", "create");
    if (!hasPermission) return;
    setEditMode(false);
    setTicketToEdit(null);
    setShowCreateTicket(true);
  };
  const [checkUserLoading, setCheckUserLoading] = useState(false);
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Tickets", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error Check Permission:", error);
    } finally {
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);
  const renderHeader = () => {
    return (
      <div style={{ marginBottom: "22px" }}>
        <div className="brood_comes_div">
          <div className="row align-items-center">
            <div className="col-md-6 brood_comes_heading">
              <h2>
                <div className="brood_comes_part">
                  <FaTicketAlt />
                </div>
                Event Tickets
              </h2>
              {/* <nav
                style={{
                  fontSize: "14px",
                  color: "#666666",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <Link
                  to="/events/admin/"
                  style={{
                    color: "#184778",
                    textDecoration: "none",
                    fontWeight: "500",
                    transition: "color 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.color = "#2563eb";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.color = "#184778";
                  }}
                >
                  AMASI
                </Link>
                <span style={{ color: "#d1d5db" }}>›</span>
                <span style={{ color: "#6b7280" }}>Tickets</span>
              </nav> */}
            </div>
            <div className="col-md-6 text-end">
              <button
                className="btn btn-outline-primary "
                onClick={() => {
                  handleCreateTicket();
                }} >
                <FaPlus />
                Create Ticket
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderErrorAlert = () => {
    if (!apiError) return null;
    return (
      <div
        style={{
          backgroundColor: "#fef2f2",
          border: "1px solid #fecaca",
          borderRadius: "8px",
          padding: "16px",
          marginBottom: "22px",
          color: "#dc2626",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <i className="fa fa-exclamation-triangle"></i>
          <span>{apiError}</span>
        </div>
      </div>
    );
  };
  const renderLoadingSpinner = () => {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "60px 20px",
          color: "#666666",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "40px",
            border: "4px solid #f3f3f3",
            borderTop: "4px solid #184778",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 16px auto",
          }}
        ></div>
        <p style={{ margin: "0", fontSize: "16px" }}>Loading tickets...</p>
      </div>
    );
  };
  const renderTabs = () => {
    const tabs = [
      { key: "all", title: "All", count: tabCounts.all },
      { key: "onsale", title: "On Sale", count: tabCounts.onsale },
      { key: "paused", title: "Paused", count: tabCounts.paused },
      { key: "scheduled", title: "Scheduled", count: tabCounts.scheduled },
      { key: "soldout", title: "Sold Out", count: tabCounts.soldout },
      { key: "draft", title: "Drafts", count: tabCounts.draft },
      { key: "archived", title: "Archived", count: tabCounts.archived },
      { key: "deleted", title: "Deleted", count: tabCounts.deleted },
    ];
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          padding: "15px 24px",
          borderRadius: "16px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          marginBottom: "22px",
          border: "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {tabs.map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    padding: "10px 18px",
                    border: isActive
                      ? "2px solid #184778"
                      : "2px solid transparent",
                    backgroundColor: isActive ? "#184778" : "#f8fafc",
                    color: isActive ? "#ffffff" : "#64748b",
                    fontSize: "13px",
                    fontWeight: isActive ? "600" : "500",
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                  onMouseOver={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "#184778";
                      e.currentTarget.style.color = "#ffffff";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isActive) {
                      e.currentTarget.style.backgroundColor = "#f8fafc";
                      e.currentTarget.style.color = "#64748b";
                    }
                  }}
                >
                  <span>{tab.title}</span>
                  <span>{tab.count || 0}</span>
                </button>
              );
            })}
          </div>
          <div style={{ position: "relative", minWidth: "280px" }}>
            <i
              className="fa fa-search"
              style={{
                position: "absolute",
                left: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#94a3b8",
                fontSize: "14px",
              }}
            />
            <input
              type="text"
              placeholder="Search Tickets..."
              value={searchQuery}
              onChange={handleSearchChange}
              style={{
                padding: "11px 16px 11px 44px",
                border: "2px solid #e2e8f0",
                borderRadius: "10px",
                fontSize: "14px",
                outline: "none",
                width: "100%",
                transition: "all 0.3s ease",
                backgroundColor: "#ffffff",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#184778";
                e.target.style.boxShadow = "0 0 0 3px rgba(24, 71, 120, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e2e8f0";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>
      </div>
    );
  };
  const renderTicketsTable = () => {
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          padding: "32px",
          border: "1px solid #f0f0f0",
        }}
      >
        {loading ? (
          renderLoadingSpinner()
        ) : (
          <div style={{ overflowX: "auto" }}>
            <MDBDataTable
              noBottomColumns
              className="table table-hover js-basic-example dataTable table-custom spacing5"
              entriesOptions={[5, 10, 20, 25]}
              entries={10}
              paging
              pagesAmount={5}
              data={tableData}
              sortRows={["name"]}
              preserveScroll={true}
              preserveState={true}
              clickableRows={false}
              searching={false}
            />
          </div>
        )}
        <div
          style={{
            marginTop: "24px",
            fontSize: "14px",
            color: "#64748b",
            textAlign: "center",
            padding: "12px",
            backgroundColor: "#f8fafc",
            borderRadius: "8px",
          }}
        >
          {loading
            ? "Loading..."
            : `Showing 1 to ${tickets.length} records of ${tabCounts[activeTab] || 0
            }`}
        </div>
      </div>
    );
  };
  const renderMainContent = () => {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f9fafb",
          padding: "24px 15px",
        }}
      >
        {checkUserLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "500px" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div>
            {renderHeader()}
            {renderErrorAlert()}
            {renderTabs()}
            {renderTicketsTable()}
          </div>
        )}
      </div>
    );
  };
  return (
    <>
      {renderMainContent()}
      <GuestTicketModal
        show={showGuestTicketModal}
        onHide={handleCloseGuestTicketModal}
        guestTicket={selectedGuestTicket}
        parentTicketName={selectedParentTicketName}
        apiTickets={apiTickets}
        parentTicketId={selectedParentTicketId}
      />
      {prevTicket && showTicketPreview && (
        <TicketPreviewModal
          show={showTicketPreview}
          onClose={() => setShowTicketPreview(false)}
          ticket={prevTicket}
        />
      )}
      <ConfirmationModal
        show={showDeleteConfirmation}
        title="Delete Ticket"
        message={`Are you sure you want to delete the ticket "${ticketToDelete?.name}"? This action cannot be undone.`}
        confirmButtonText="Delete"
        confirmButtonVariant="danger"
        onConfirm={handleDeleteConfirmed}
        onCancel={() => {
          setShowDeleteConfirmation(false);
          setTicketToDelete(null);
        }}
      />
      {showCreateTicket && (
        <CreateTicket
          show={showCreateTicket}
          onHide={() => {
            setShowCreateTicket(false);
            setEditMode(false);
            setTicketToEdit(null);
          }}
          onCreateTicket={handleCreateTicket}
          setShowAddOns={setShowAddOns}
          editMode={editMode}
          ticketToEdit={ticketToEdit}
          onOpenTaxSettings={handleOpenTaxSettings}
          onUpdate={loadTickets}
          getValidation={getValidation}
        />
      )}
      <Modal
        show={showAddGroup}
        onHide={() => setShowAddGroup(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-bottom-0">
          <Modal.Title className="fw-bold">Add Group</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <Form.Group>
            <Form.Label>
              Group Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="text" placeholder="Add a name to the Group" />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-top-0">
          <Button variant="secondary" onClick={() => setShowAddGroup(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddGroup}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAddOns}
        onHide={() => setShowAddOns(false)}
        centered
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-bottom-0">
          <Modal.Title className="fw-bold">Choose Add-ons</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="add-ons-list">
            <div className="add-on-item d-flex align-items-center p-3 border rounded mb-3 shadow-sm">
              <Form.Check label="" type="checkbox" className="me-3" />
              <div className="flex-grow-1">
                <div className="add_on_resdenlt_div">
                  <div className="res_packge_div">
                    <h6 className="mb-0 fw-bold">Residential Package</h6>
                    <small className="text-muted">3 variants</small>
                  </div>
                  <div>
                    <p className="mb-0 fw-medium">USD 220 - 405</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-on-item d-flex align-items-center p-3 border rounded mb-3 shadow-sm">
              <Form.Check label="" type="checkbox" className="me-3" />
              <div className="flex-grow-1">
                <div className="add_on_resdenlt_div">
                  <div className="res_packge_div">
                    <h6 className="mb-0 fw-bold">
                      Residential Package (3 Nights 4 Days)
                    </h6>
                    <small className="text-muted">3 variants</small>
                  </div>
                  <div>
                    <p className="mb-0 fw-medium">INR 19000 - 35000</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-on-item d-flex align-items-center p-3 border rounded mb-3 shadow-sm">
              <Form.Check label="" type="checkbox" className="me-3" />
              <div className="flex-grow-1">
                <div className="add_on_resdenlt_div">
                  <div className="res_packge_div">
                    <h6 className="mb-0 fw-bold">
                      Residential Package (4 Nights 5 Days)
                    </h6>
                    <small className="text-muted">3 variants</small>
                  </div>
                  <div>
                    <p className="mb-0 fw-medium">INR 25000 - 46000</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top-0">
          <Button variant="secondary" onClick={() => setShowAddOns(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddOns}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <TaxSettingsDrawer
        show={showTaxSettings}
        onClose={() => setShowTaxSettings(false)}
      />
    </>
  );
};
export default EventTickets;